"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useIsTouchPointer } from "../../hooks/useShouldUseDrawer.js";
import { cn } from "../../utils/cn.js";
import { drawerVariants } from "./Drawer.variants.js";
const { handle: handle } = drawerVariants();
const DrawerHandle_DrawerHandle = /*#__PURE__*/ forwardRef(function({ className, slots, ...props }, ref) {
    const isTouch = useIsTouchPointer();
    if (!isTouch) return null;
    return /*#__PURE__*/ jsx("hr", {
        ref: ref,
        tabIndex: -1,
        className: cn(handle(), className, slots?.handle),
        ...props
    });
});
export { DrawerHandle_DrawerHandle as DrawerHandle };
